import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Paper, Stack, Typography, Dropdown, DropdownMenuItem} from 'views/components';
import {Check} from 'views/icons';
import {translate, Translate} from 'views/module';

import {FOLLOW_UP_OPTIONS} from '../../../utils/constants';

const FollowUpCard = (props) => {
  const {
    isFollowUpRequired,
    setIsFollowUpRequired,
    bestFollowUpTime,
    setBestFollowUpTime,
  } = props;

  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const handleButtonClick = (isFollowUpRequired) => {
    isFollowUpRequired ? setIsFollowUpRequired(true) : setIsFollowUpRequired(false);
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: '12px',
        backgroundColor: '#efebee',
        p: 3,
      }}
    >
      <Typography
        sx={{
          fontSize: '1.2rem',
          fontWeight: 400,
          color: '#b81c1c',
        }}
      >
        <Translate expression='eventFeedback.FollowUp.Question'/>
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        sx={{mt: 1}}
      >
        <Button
          onClick={() => handleButtonClick(true)}
          sx={{
            backgroundColor: isFollowUpRequired ? '#10a4a0' : '#fff',
            color: isFollowUpRequired ? 'color.white' : 'color.black',
            borderRadius: '12px',
            px: 1.5,
            py: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: '1.1rem',
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            <Translate expression='eventFeedback.FollowUp.YesLabel' />
          </Typography>
        </Button>
        <Button
          onClick={() => handleButtonClick(false)}
          sx={{
            backgroundColor: isFollowUpRequired ? 'color.white' : '#e1e7ef',
            color: 'color.black',
            borderRadius: '12px',
            px: 1.5,
            py: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: '1.1rem',
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            <Translate expression='eventFeedback.FollowUp.NoLabel' />
          </Typography>
        </Button>
      </Stack>
      {
        isFollowUpRequired &&
        <Stack
          spacing={1}
          sx={{mt: 2}}
        >
          <Translate expression='eventFeedback.FollowUp.BestContactTime.Title'/>
          <Dropdown
            value={bestFollowUpTime}
            onChange={(newValue) => setBestFollowUpTime(newValue)}
            onOpen={() => setDropdownOpen(true)}
            onClose={() => setDropdownOpen(false)}
            renderValue={(selected) => translate(FOLLOW_UP_OPTIONS[selected])}
            sx={{
              'width': '100%',
              'backgroundColor': 'color.white',
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#10a4a0',
                borderWidth: '1.5px',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#10a4a0',
                boxShadow: '0 0 0 4px #10a4a033',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  backgroundColor: 'color.white',
                },
              },
            }}
          >
            {
              Object.entries(FOLLOW_UP_OPTIONS).map(([option, translationKey]) => {
                return (
                  <DropdownMenuItem
                    key={option}
                    value={option}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: '#10a4a033'
                        ,
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: '#10a4a033'
                        ,
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      {
                        dropdownOpen && (
                          <Check
                            sx={{
                              visibility: bestFollowUpTime === option ? 'visible' : 'hidden',
                              mr: 1,
                            }}
                          />
                        )
                      }
                      <Translate expression={translationKey} />
                    </Box>
                  </DropdownMenuItem>
                );
              })
            }
          </Dropdown>
        </Stack>
      }
    </Paper>
  );
};

FollowUpCard.propTypes = {
  isFollowUpRequired: PropTypes.bool.isRequired,
  setIsFollowUpRequired: PropTypes.func.isRequired,
  bestFollowUpTime: PropTypes.string,
  setBestFollowUpTime: PropTypes.func.isRequired,
};

export default React.memo(FollowUpCard);
